export const showHideMenuItems = (items, visibility) => {
  items.forEach((item) => {
    const visibilityCondition = visibility[item.id]
    if (visibilityCondition) {
      item.hidden = !visibilityCondition
    }
  })
}
